import { createSlice } from "@reduxjs/toolkit";
import { getReportTaxes } from "./reportTaxesAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  taxes:[],
  latestRequestId: null,
};

const reportTaxesSlice = createSlice({
  name: "reportTaxes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReportTaxes.pending, (state, action) => {
        state.loading = true;
        state.taxes = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getReportTaxes.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.taxes = action.payload;
        state.error = null;
      })
      .addCase(getReportTaxes.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default reportTaxesSlice.reducer;